export default class cookieManager {
  #affKey;
  #queryArg;

  constructor(key, qArg) {
    this.#affKey = key;
    this.#queryArg = qArg;
    console.log(window.location.href);
    // detect query Arg if provided
    const url = new URL(window.location.href);
    // Checks if a value exists in the search params (boolean)
    if (url.searchParams.has(this.#queryArg)) {
      if ("erase" == url.searchParams.get(this.#queryArg)) {
        this.#forget();
      } else {
        this.#remember(url.searchParams.get(this.#queryArg));
      }
    }
  }

  /**
   *
   * @param {*} code string/object - could either a irclickid code or a object with code and phoneNumber
   */
  #remember(code) {
    // Store data
    localStorage.setItem(this.#affKey, code);
    console.log(code);
  }

  recall() {
    // retrieve code from local storage
    return localStorage.getItem(this.#affKey);
  }

  #forget() {
    localStorage.removeItem(this.#affKey);
  }
}
